import Vue             from 'vue'
import Router          from 'vue-router'
import DefaultLayout   from './layouts/Default.vue'
import Home            from './views/Home.vue'
import About           from './views/About.vue'
import Compositeur     from './components/Compositeur.vue'
import Partitions      from './components/Partitions.vue'
import WriteSyntaxHelp from './components/WriteSyntaxHelp.vue';
import FourOhFour      from './components/FourOhFour.vue'
import PartitionHelp   from './views/PartitionHelp.vue'

Vue.use(Router);

export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      children: [
        { path: '/', redirect: '/partitions'  },
        { path: '/home'               , name: 'home'            , component: Home  },
        { path: '/help'               , name: 'help'            , component: PartitionHelp  },
        { path: '/partitions'         , name: 'partitions'      , component: Partitions },
        { path: '/partitions/:partid'                           , component: Partitions },
        { path: '/writesyntaxhelp'    , name: 'writesyntaxhelp' , component: WriteSyntaxHelp },
        { path: '/compositeur'        , name: 'compositeur'     , component: Compositeur },
        { path: '/about'              , name: 'about'           , component: About },
        { path: '/four-ho-four'       , name: 'fourohfour'      , component: FourOhFour }, // Gasp!
        { path: '*', redirect: '/four-ho-four' }, // Gasp!
      ]
    }
  ]
});
